import types from './types'

export const updateFilters = (filters) => ({ type: types.SEARCH_UPDATE_FILTERS, filters })
export const search = (phrase, limit, key) => ({ type: types.SEARCH_ATTEMPT, phrase, limit, key })
export const cancel = (phrase) => ({ type: types.SEARCH_CANCEL, phrase })
export const clear = () => ({ type: types.SEARCH_CLEAR })
export const focus = () => ({ type: types.SEARCH_FOCUSED })

export const searchStart = (key) => ({ type: types.SEARCH_START, key })
export const searchSuccess = (key, data, count) => ({ type: types.SEARCH_SUCCESS, key, data, count })
export const searchFailure = (key, error, code) => ({ type: types.SEARCH_FAILURE, key, error, code })
export const searchResultClick = () => ({ type: types.SEARCH_RESULT_CLICK })

export default {
  updateFilters,
  search,
  cancel,
  clear,
  focus,
  searchStart,
  searchSuccess,
  searchFailure,
  searchResultClick,
}